import React, { Component } from "react";
import PropTypes from "prop-types";
import { Mutation } from "react-apollo";
import { Fieldset } from "rbx";
import { EditFormButtonGroup } from "../inputs";

import Section from "../Section";
import {
  UPDATE_SYSTEM_CODE_MUTATION,
  DELETE_SYSTEM_CODE_MUTATION
} from "../../graphql/SystemCodes/SystemCodes.graphql";
import { ourToast as toast } from "../../utils";

import SystemCodeForm from "./SystemCodeForm";

class EditSystemCodeForm extends Component {
  state = {
    Category: "",
    CodeName: "",
    CodeId: "",
    CodeDescription: "",
    Active: true,
    ListOrder: "",
    ...this.props.code
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const {
      Category,
      CodeName,
      CodeId,
      CodeDescription,
      Active,
      ListOrder
    } = this.state;
    const { setModalOpen, where } = this.props;
    return (
      <Mutation
        mutation={UPDATE_SYSTEM_CODE_MUTATION}
        refetchQueries={["ALL_SYSTEM_CODES_QUERY"]}
        variables={{
          data: {
            Category: where ? where.Category : Category,
            CodeName,
            CodeId,
            CodeDescription,
            Active,
            ListOrder: parseInt(ListOrder)
          },
          where: {
            RecId: this.props.code.RecId
          }
        }}
      >
        {(updateSystemCode, { loading, error }) => (
          <Section title="Edit System Code">
            <form
              id="edit-system-code-form"
              onSubmit={async e => {
                e.preventDefault();
                try {
                  await updateSystemCode();
                  setModalOpen();
                  toast.success("System Code updated successfully.");
                } catch (err) {
                  toast.error("Error updating System Code.");
                }
              }}
            >
              <Fieldset disabled={loading}>
                <SystemCodeForm
                  inputs={{
                    Category,
                    CodeName,
                    CodeId,
                    CodeDescription,
                    Active,
                    ListOrder
                  }}
                  where={where}
                  onChange={this.onChange}
                />
                <EditFormButtonGroup
                  confirmModalMessage="If this code has been previously used, please make it inactive instead of deleting it. Are you sure you want to delete this code at this time?"
                  deleteMutation={DELETE_SYSTEM_CODE_MUTATION}
                  form="edit-system-code-form"
                  refetchQueries={["ALL_SYSTEM_CODES_QUERY"]}
                  variables={{ where: { RecId: this.props.code.RecId } }}
                  onComplete={setModalOpen}
                />
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}
EditSystemCodeForm.propTypes = {
  setModalOpen: PropTypes.func,
  code: PropTypes.object,
  where: PropTypes.object
};
export default EditSystemCodeForm;
